import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6e2e5ba2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "modal-dialog" }
const _hoisted_2 = { class: "modal-content" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "modal-header" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "fs-9 fw-bold text-center w-100" }, "交換商品"),
  /*#__PURE__*/_createElementVNode("button", {
    type: "button",
    class: "btn-close",
    "data-bs-dismiss": "modal",
    "aria-label": "Close"
  })
], -1))
const _hoisted_4 = { class: "modal-body mx-4" }
const _hoisted_5 = { class: "d-flex text-green align-items-center justify-content-center box-point mx-auto my-4" }
const _hoisted_6 = { class: "font-weight" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "fs-45 fw-bold" }, "pt", -1))
const _hoisted_8 = { class: "fs-75 text-center mb-2" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_10 = { class: "fs-75 text-center mb-4" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_12 = { class: "modal-footer d-flex justify-content-center" }
const _hoisted_13 = { class: "modal-dialog" }
const _hoisted_14 = { class: "modal-content" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex justify-content-end p-3" }, [
  /*#__PURE__*/_createElementVNode("button", {
    type: "button",
    class: "btn-close",
    "data-bs-dismiss": "modal",
    "aria-label": "Close"
  })
], -1))
const _hoisted_16 = { class: "modal-body" }
const _hoisted_17 = { class: "text-center fw-bold fs-7" }
const _hoisted_18 = { class: "text-center fw-bold fs-7" }
const _hoisted_19 = { class: "text-center fw-bold fs-75" }
const _hoisted_20 = { class: "d-flex justify-content-center my-4" }
const _hoisted_21 = { class: "box-success text-danger" }
const _hoisted_22 = { class: "text-center fw-bold fs-7 my-3" }
const _hoisted_23 = { class: "d-flex justify-content-center mb-4" }
const _hoisted_24 = { class: "modal-dialog" }
const _hoisted_25 = { class: "modal-content" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex justify-content-end p-3" }, [
  /*#__PURE__*/_createElementVNode("button", {
    type: "button",
    class: "btn-close",
    "data-bs-dismiss": "modal",
    "aria-label": "Close"
  })
], -1))
const _hoisted_27 = { class: "modal-body" }
const _hoisted_28 = { class: "fw-bold text-center" }
const _hoisted_29 = { class: "d-flex justify-content-center mb-4" }

import Button from '@/components/button/index.vue'
import { translate } from '@/languages/i18n'
import yelloopPointsService from '@/services/yelloop-points.services.ts'
import { numberWithCommas } from '@/constants/common.ts'
// import { useRouter } from 'vue-router'
import { Modal } from 'bootstrap'
import { computed, ComputedRef, onMounted, ref } from 'vue'
import { POINT_STORE, ROOT_STORE } from '@/store/constants'
import { useStore } from 'vuex'


export default /*#__PURE__*/_defineComponent({
  props: {
  pointCurrent: String,
},
  setup(__props) {

const props = __props

const dataPointAlumni = computed(() => store.getters[POINT_STORE.GETTERS.POINTS])
const modalConfirm = ref()
const modalSuccess = ref()
const modalFailed = ref()
const isMobile = computed<ComputedRef<boolean>>(() => store.getters[ROOT_STORE.GETTERS.CHECK_MOBILE_DEVICE])

// const router = useRouter()
const store = useStore()


onMounted(() => {
  modalConfirm.value = new Modal(document.getElementById('productModal'))
  modalSuccess.value = new Modal(document.getElementById('productModalSuccess'))
  modalFailed.value = new Modal(document.getElementById('productModalFailed'))
})
const loadingSubmit = ref<boolean>(false)
const urlGift = ref()
const exchangePoints = async (): void => {
  loadingSubmit.value = true
  try {
    let id = 1
    switch (props.pointCurrent) {
      case '500':
        id = 1
        break
      case '1000':
        id = 2
        break
      case '5000':
        id = 3
        break
    }
    const response = await yelloopPointsService.postPointExChange({
      id: id,
    })
    if (response?.status === 200) {
      urlGift.value = response.data.data.giftpad_url
      store.dispatch(POINT_STORE.ACTIONS.SET_POINTS)
      modalSuccess.value?.show()
    } else {
      modalFailed.value?.show()
    }
    modalConfirm.value?.hide()
    //2022/09/12 TienNV Fix double click button confirm
    setTimeout(() => {
      loadingSubmit.value = false
    }, 2000)
  } catch (error) {
    console.log(error)
    modalFailed.value?.show()
    modalConfirm.value?.hide()
    loadingSubmit.value = false
  }
}

const transitToFaq = () => {
  window.open('https://support-yelloop.zendesk.com/hc/ja')
  modalFailed.value?.hide()
}

const transitGiftpad = () => {
  if (urlGift.value) window.open(urlGift.value, '_blank')
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: "modal fade",
      id: "productModal",
      tabindex: "-1",
      "aria-labelledby": "productModal",
      "aria-hidden": "true",
      ref: (_value, _refs) => {
        _refs['modalTest'] = _value
      }
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, _toDisplayString(_unref(numberWithCommas)(Number(__props.pointCurrent))), 1),
              _createElementVNode("div", null, [
                _createElementVNode("div", {
                  class: _normalizeClass(["status bg-green text-white d-flex align-items-center justify-content-center fw-bold", _unref(isMobile) ? 'fs-85' : 'fs-8'])
                }, "交換", 2),
                _hoisted_7
              ])
            ]),
            _createElementVNode("p", {
              class: _normalizeClass([_unref(isMobile) ? 'fs-7' : 'fs-9', 'fw-bold text-center mb-2'])
            }, _toDisplayString(_unref(translate)('SJ10textProductModal1')) + _toDisplayString(_unref(numberWithCommas)(Number(__props.pointCurrent))) + "円分", 3),
            _createElementVNode("p", _hoisted_8, [
              _createTextVNode(_toDisplayString(_unref(translate)('SJ10textProductModal2')), 1),
              _hoisted_9,
              _createTextVNode(_toDisplayString(_unref(translate)('SJ10textProductModal3')), 1)
            ]),
            _createElementVNode("p", _hoisted_10, _toDisplayString(_unref(translate)('SJ10textProductModal4')), 1),
            _createElementVNode("p", {
              class: _normalizeClass([['text-center text-green fw-bold mb-2', _unref(isMobile) ? 'fs-16' : 'fs-9 mx-5'], ""])
            }, [
              _createTextVNode(_toDisplayString(_unref(numberWithCommas)(Number(__props.pointCurrent))) + _toDisplayString(_unref(translate)('SJ10textProductModal5')), 1),
              _hoisted_11,
              _createTextVNode(_toDisplayString(_unref(translate)('SJ10textProductModal6')), 1)
            ], 2)
          ]),
          _createElementVNode("div", _hoisted_12, [
            (!_unref(isMobile))
              ? (_openBlock(), _createBlock(Button, {
                  key: 0,
                  title: _unref(translate)('CloseButton'),
                  type: 'secondary',
                  class: _normalizeClass('fw-bold'),
                  "data-bs-dismiss": 'modal'
                }, null, 8, ["title"]))
              : _createCommentVNode("", true),
            _createVNode(Button, {
              title: '交換する',
              type: 'secondary',
              class: _normalizeClass('fw-bold'),
              onClick: exchangePoints,
              loading: loadingSubmit.value,
              disabled: loadingSubmit.value || Number(_unref(dataPointAlumni)?.total_points) < Number(__props.pointCurrent)
            }, null, 8, ["loading", "disabled"]),
            (_unref(isMobile))
              ? (_openBlock(), _createBlock(Button, {
                  key: 1,
                  title: _unref(translate)('back'),
                  type: 'secondary',
                  class: _normalizeClass('fw-bold'),
                  "data-bs-dismiss": 'modal'
                }, null, 8, ["title"]))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ], 512),
    _createElementVNode("div", {
      class: "modal fade",
      id: "productModalSuccess",
      tabindex: "-1",
      "aria-labelledby": "productModalSuccess",
      "aria-hidden": "true",
      ref: (_value, _refs) => {
        _refs['modalTest'] = _value
      }
    }, [
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("div", _hoisted_14, [
          _hoisted_15,
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("p", _hoisted_17, _toDisplayString(_unref(translate)('SJ10exchangeSuccess')), 1),
            _createElementVNode("p", _hoisted_18, _toDisplayString(_unref(translate)('SJ10selectService')), 1),
            _createElementVNode("p", _hoisted_19, _toDisplayString(_unref(translate)('SJ10selectService2')), 1),
            _createElementVNode("div", _hoisted_20, [
              _createVNode(Button, {
                title: _unref(translate)('SJ10exchange'),
                type: 'primary',
                class: _normalizeClass('fw-bold'),
                "data-bs-dismiss": 'modal',
                onClick: transitGiftpad
              }, null, 8, ["title"])
            ]),
            _createElementVNode("div", _hoisted_21, [
              _createElementVNode("div", _hoisted_22, _toDisplayString(_unref(translate)('SJ10textModal1')), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_23, [
            _createVNode(Button, {
              title: _unref(translate)('close'),
              type: 'secondary',
              class: _normalizeClass('fw-bold'),
              "data-bs-dismiss": 'modal'
            }, null, 8, ["title"])
          ])
        ])
      ])
    ], 512),
    _createElementVNode("div", {
      class: "modal fade",
      id: "productModalFailed",
      tabindex: "-1",
      "aria-labelledby": "productModalFailed",
      "aria-hidden": "true",
      ref: (_value, _refs) => {
        _refs['modalTest'] = _value
      }
    }, [
      _createElementVNode("div", _hoisted_24, [
        _createElementVNode("div", _hoisted_25, [
          _hoisted_26,
          _createElementVNode("div", _hoisted_27, [
            _createElementVNode("p", _hoisted_28, _toDisplayString(_unref(translate)('SJ10textModal4')), 1),
            _createElementVNode("span", {
              class: _normalizeClass(["justify-content-center fw-bold my-4", _unref(isMobile) ? '' : 'd-flex'])
            }, [
              _createTextVNode(_toDisplayString(_unref(translate)('SJ10textModal5')) + " ", 1),
              _createElementVNode("u", {
                class: "text-green",
                onClick: transitToFaq
              }, _toDisplayString(_unref(translate)('here')), 1),
              _createTextVNode(_toDisplayString(_unref(translate)('SJ10textModal6')), 1)
            ], 2)
          ]),
          _createElementVNode("div", _hoisted_29, [
            _createVNode(Button, {
              title: _unref(translate)('close'),
              type: 'secondary',
              class: _normalizeClass('fw-bold'),
              "data-bs-dismiss": 'modal'
            }, null, 8, ["title"])
          ])
        ])
      ])
    ], 512)
  ], 64))
}
}

})